export const randomInteger = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;

export const roundUp = (num: number, precision = 1) => {
  const multiplier = 10 ** precision;
  return Math.round((num + Number.EPSILON) * multiplier) / multiplier || 0;
};
